import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { OfferStoreContext } from "@gp/components";
import { redirect } from "@state";

import { SideMenuLinkCount } from ".";
import { TSection } from "@data-types/offer/live/Section";

export type SideMenuLinkItem = {
	translationKey: string;
	iconClassExtension: string;
	countKey?: string;
	url: string;
	callOnUserAction?: () => void;
};

export const SideMenuLink = observer(function SideMenuLink(props: {
	item: SideMenuLinkItem;
}) {
	const {
		item: {
			translationKey,
			iconClassExtension,
			countKey,
			url,
			callOnUserAction, // Function to execute for this specific item
		},
	} = props;

	// @ts-expect-error
	const { selectedSport, isOfferMenuOpen, isExpandDisabled } =
		useContext(OfferStoreContext);
	const { pathname } = useLocation();
	const { t } = useTranslation();

	const isDefaultSelection = url.includes(TSection.Matches);
	const isActive =
		(!isDefaultSelection && url === pathname) ||
		(isDefaultSelection && url === pathname && selectedSport == null);

	const isLive = url.includes("live");

	const toggleClasses = classNames(
		"nav--secondary__toggle u-icon u-icon--xtny",
		{
			"u-icon--caret--right u-color--core--snow":
				!isOfferMenuOpen && isActive,
			"u-icon--close u-color--core--snow":
				isOfferMenuOpen && !isExpandDisabled && isActive,
			"u-icon--caret--right": !isOfferMenuOpen && !isActive,
			"u-icon--close": isOfferMenuOpen && !isExpandDisabled && !isActive,
		}
	);

	return (
		<li
			className={classNames("nav--secondary__item", {
				"nav--live__item": isLive,
			})}
		>
			<button
				className={classNames("nav--secondary__link", {
					"is-selected": isActive,
				})}
				onClick={() => {
					redirect(url, true);
					if (typeof callOnUserAction === "function") {
						callOnUserAction();
					}
				}}
			>
				<div className="nav--secondary__icon">
					<SideMenuLinkCount countKey={countKey} />

					<i
						className={`nav--secondary__icon u-icon u-icon--lrg u-icon--${iconClassExtension}`}
					/>
				</div>

				<div className="nav--secondary__title">
					{t<string>(translationKey)}
				</div>

				{iconClassExtension == "all" && <i className={toggleClasses} />}
			</button>
		</li>
	);
});
